export const PRICING_WORKLOAD_QUERY_KEY = (userIds?: string[]) => [
  "pricingWorkloads",
  ...(userIds || []),
];

export const BRIEF_PRICING_AGGREGATE_QUERY_KEY = (briefId: string) => [
  "briefPricingAggregate",
  briefId,
];

export const PRICING_POC_FACETS_QUERY_KEY = (
  briefId: string,
  pocId: string
) => ["pricingPocFacets", briefId, pocId];
